import { createActionsGroup } from 'utils/redux-utils'

export const allCategoriesListActions = createActionsGroup(
  'ALL_CATEGORIES_LIST',
)
